import { ClaimControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */
export const useArchiveClaims = () =>
  useMutationWithLoading(
    async (param: { claimId: string; status: boolean; xTENANTID?: string }) =>
      new ClaimControllerApi(getConfigObject()).updateClaimArchiveStatus1(
        param.claimId,
        param.status,
        param.xTENANTID //xTENANTID
      )
  );
